import React, { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { FaFilter } from "react-icons/fa";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

const FilterPopover = ({
  selectedType,
  setSelectedType,
  filterValues,
  fetchServices,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleSelect = (value) => {
    setSelectedType(value);
    handleClose();
    fetchServices(value);
  };

  return (
    <>
      <div
        onClick={handleOpen}
        className="flex w-[250px] items-center justify-between px-3 py-2 bg-gray-100 rounded-lg cursor-pointer hover:bg-gray-200 transition"
      >
        <div className="flex items-center">
          <FaFilter className="text-[#367fa9] mr-2 text-[12px]" />
          <span className="text-[#367fa9] text-sm">
            {selectedType === "all"
              ? "All Services"
              : filterValues.find((f) => f.value === selectedType)?.label || "Filter by Type"}
          </span>
        </div>
        {anchorEl ? (
          <FaChevronUp className="text-[#367fa9] ml-2 text-[10px]" />
        ) : (
          <FaChevronDown className="text-[#367fa9] ml-2 text-[10px]" />
        )}
      </div>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          sx: {
            minWidth: '250px' // Match width with parent div
          }
        }}
      >
        {filterValues.map((item) => (
          <MenuItem key={item.value} onClick={() => handleSelect(item.value)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default FilterPopover;
